
export default function (Component) {
  Component.options.__source = "src/views/Test/index.vue"
}
